import React from 'react';
import QueueAnim from 'rc-queue-anim';
import Texty from 'rc-texty';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';
/* replace-start */
import './index.less';
/* replace-end */

function pricing3(props) {
  const { ...tagProps } = props;
  const { dataSource } = tagProps;
  delete tagProps.dataSource;
  delete tagProps.isMobile;

  const setHtml = (data) => {
    return data.map((value, index) => {
      return (
        <div {...value} key={index}>
          <div
            {...value.title}
            data-edit="texty"
          >
            <Texty type="mask-bottom">
              {value.title.children}
            </Texty>
          </div>
          <QueueAnim
            type="left"
            delay={300}
            {...value.row}
          >
            {value.row.children.map(getChildrenToRender)}
          </QueueAnim>
          {
            value.content.children.length > 0 && (
            <QueueAnim
              type="left"
              delay={400}
              {...value.content}
            >
              {value.content.children.map(getChildrenToRender)}
            </QueueAnim>
            )
          }
        </div>
      );
    });
  };

  return (
    <OverPack
      {...tagProps}
      {...dataSource.wrapper}
    >
      <div {...dataSource.page}>
        <TweenOne
          animation={{ x: '-=500', opacity: 0, type: 'from', ease: 'easeOutQuad' }}
          key="leftImg"
          duration={1000}
          {...dataSource.leftImg}
          data-edit="image"
        >
          <img src={dataSource.leftImg.children} width="100%" alt="img" />
        </TweenOne>
        <TweenOne
          animation={{ x: '+=500', opacity: 0, type: 'from', ease: 'easeOutQuad' }}
          duration={1000}
          {...dataSource.right}
        >
          {
          setHtml(dataSource.right.children)
        }
        </TweenOne>
      </div>
    </OverPack>
  );
}

export default pricing3;
